import { render, staticRenderFns } from "./GeminiIcon.vue?vue&type=template&id=b3525e06&scoped=true"
import script from "./GeminiIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./GeminiIcon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3525e06",
  null
  
)

export default component.exports